module.exports = {
	"id": "BT",
	"name": "Bhutan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.022528,
			"6": null,
			"7": 0.005632,
			"8": null,
			"9": 0.002816,
			"10": null,
			"11": 0.02816,
			"12": 0.025344,
			"13": null,
			"14": 0.011264,
			"15": null,
			"16": 0.008448,
			"17": 0.002816,
			"18": 0.067584,
			"19": 0.005632,
			"20": 0.008448,
			"21": 0.033792,
			"22": 0.008448,
			"23": 0.016896,
			"24": 0.008448,
			"25": 0.01408,
			"26": 0.005632,
			"27": 0.019712,
			"28": 0.04224,
			"29": 0.016896,
			"30": 0.092928,
			"31": 0.045056,
			"32": 0.01408,
			"33": 0.115456,
			"34": 0.008448,
			"35": 0.036608,
			"36": 0.011264,
			"37": 0.005632,
			"38": 0.022528,
			"39": 0.016896,
			"40": 0.01408,
			"41": 0.008448,
			"42": 0.002816,
			"43": 0.160512,
			"44": 0.050688,
			"45": 0.02816,
			"46": 0.053504,
			"47": 0.078848,
			"48": 0.033792,
			"49": 0.653312,
			"50": 0.109824,
			"51": 0.385792,
			"52": 0.371712,
			"53": 11.300608,
			"54": 2.694912,
			"55": 0.287232,
			"56": 0.121088,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.047872,
			"4": 0.005632,
			"5": null,
			"6": 0.005632,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.019712,
			"11": 0.002816,
			"12": 0.022528,
			"13": null,
			"14": 0.011264,
			"15": 0.008448,
			"16": 0.008448,
			"17": 0.01408,
			"18": 0.033792,
			"19": 0.030976,
			"20": 0.002816,
			"21": 0.002816,
			"22": 0.008448,
			"23": 0.008448,
			"24": 0.008448,
			"25": 0.005632,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.02816,
			"30": 0.011264,
			"31": 0.01408,
			"32": 0.008448,
			"33": 0.005632,
			"34": 0.002816,
			"35": 0.019712,
			"36": 0.01408,
			"37": 0.033792,
			"38": 0.019712,
			"39": 0.016896,
			"40": 0.033792,
			"41": 0.008448,
			"42": 0.022528,
			"43": 0.137984,
			"44": 0.090112,
			"45": 0.045056,
			"46": 0.039424,
			"47": 0.45056,
			"48": 0.399872,
			"49": 2.528768,
			"50": 0.785664,
			"51": null,
			"52": 0.016896,
			"3.5": 0.008448,
			"3.6": 0.036608
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.008448,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.008448,
			"34": null,
			"35": 0.059136,
			"36": 0.002816,
			"37": 0.030976,
			"38": null,
			"39": 0.011264,
			"40": 0.123904,
			"41": 0.01408,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.008448
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.002816,
			"6": 0.008448,
			"7": 0.039424,
			"8": 0.08448,
			"9": 0.18304,
			"10": 0.242176,
			"3.1": null,
			"3.2": null,
			"5.1": 0.011264,
			"6.1": 0.002816,
			"7.1": 0.002816,
			"9.1": 0.25344
		},
		"ios_saf": {
			"8": 0,
			"10": 3.00059708909,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0808626194838,
			"8.1-8.4": 0.149390263114,
			"9.0-9.2": 0.0712687493755,
			"9.3": 1.08730527893
		},
		"android": {
			"3": 0,
			"4": 0.0570450439276,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00713063049096,
			"4.1": 0.205769622739,
			"4.2-4.3": 0.514424056848,
			"4.4": 1.1796100155,
			"4.4.3-4.4.4": 1.18979663049
		},
		"ie": {
			"6": 0.01408,
			"7": null,
			"8": 0.15488,
			"9": 0.030976,
			"10": 0.050688,
			"11": 0.81664,
			"5.5": null
		},
		"op_mob": {
			"0": 1.04584775513,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0290513265315
		},
		"edge": {
			"12": 0.047872,
			"13": 0.109824,
			"14": 0.135168
		},
		"ie_mob": {
			"10": 0.237982647887,
			"11": 0.968929352113
		},
		"bb": {
			"7": 0.003592,
			"10": null
		},
		"samsung": {
			"0": 6.602096
		},
		"and_uc": {
			"0": 12.866544
		},
		"op_mini": {
			"0": 14.0905249183
		},
		"and_chr": {
			"0": 30.966688
		},
		"and_ff": {
			"0": 0.03592
		}
	},
	"total": 98.954344
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BT.json
 ** module id = 485
 ** module chunks = 0
 **/